import ListItem from "../list-item";
import {subDays, format} from "date-fns";
import Menu from "../../containers/Menu/Menu";
import {useState} from "preact/hooks";
import Icon from "../Icon/Icon";

const ChatMessageDisplaySettings = ({ loading = false, messageDisplayPeriodDays = 0, onSetMessageDisplayPeriod }) => {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!isMenuVisible);

  const onClickOption = days => {
    onSetMessageDisplayPeriod(days);
    setMenuVisible(false);
  };

  const isLimited = messageDisplayPeriodDays !== 0 && messageDisplayPeriodDays !== null && messageDisplayPeriodDays !== undefined;

  let title = "Exibir todas as mensagens";
  let subtitle = "Todas as mensagens são exibidas desde o início da conversa";
  if (isLimited) {
    title = "Mensagens ocultas após " + messageDisplayPeriodDays + (messageDisplayPeriodDays === 1 ? " dia" : " dias");
    const day = format(subDays(new Date(), messageDisplayPeriodDays - 1), "dd/MM");
    subtitle = `Somente mensagens enviadas a partir da meia noite do dia ${day} estão sendo exibidas`;
  }

  const options = [
    {label: "Exibir todas as mensagens", onClick: () => onClickOption(0), _days: 0},
    {label: "Ocultar mensagens após 1 dia", onClick: () => onClickOption(1), _days: 1},
    {label: "Ocultar mensagens após 3 dias", onClick: () => onClickOption(3), _days: 3},
    {label: "Ocultar mensagens após 1 semana", onClick: () => onClickOption(7), _days: 7},
  ].filter(({_days}) => _days !== messageDisplayPeriodDays);

  return <ListItem
    title={title}
    subtitle={subtitle}
    hoverFeedback
    fadedSubtitle
    loading={loading}
    onClick={toggleMenu}
    right={<Menu options={options} isVisible={isMenuVisible} onClickOutside={() => setMenuVisible(false)}>
      <Icon name="chevron_down" />
    </Menu>}
    style={{paddingLeft: 16, paddingRight: 16}}
  />
};

export default ChatMessageDisplaySettings;



// WEBPACK FOOTER //
// ./components/ChatMessageDisplaySettings/ChatMessageDisplaySettings.js